import React, { useState } from 'react';
import styles from './freeUserBeacon.module.scss';
import classnames from 'classnames';
import { ReactComponent as LockIcon } from 'v2/icons/lock.svg';
import { ReactComponent as CloseIcon } from 'v2/icons/close-icon.svg';
import { Beacon } from 'v2/common/Beacon/Beacon';
import { Link } from 'react-router-dom';
import { useFreeUser } from 'v2/hooks/useFreeUser';
import pluralize from 'pluralize-esm';
import { useAppSelector } from 'store';

export const FreeUserBeacon = () => {
  const waitlisted =
    useAppSelector((store) => store.user?.user?.waitlisted) ?? true;
  const [isFreeUser, freeSearcherPermission] = useFreeUser();
  const [showDetail, setShowDetail] = useState(false);
  const toggleDetail = () => {
    setShowDetail((prev) => !prev);
  };
  const requestQuantity = freeSearcherPermission?.permission_quantity;
  const requestQuantityText = pluralize('request', requestQuantity);

  const displayBeacon = isFreeUser && !waitlisted;

  return displayBeacon ? (
    <>
      <Beacon onMouseEnter={toggleDetail} />
      {showDetail && (
        <>
          <div className={classnames(styles.modal)}>
            <div className={classnames(styles.modalHeader)}>
              <LockIcon />
              <p>Your free account is limited!</p>
              <CloseIcon onClick={toggleDetail} />
            </div>
            <div className={classnames(styles.modalContent)}>
              <ul>
                <li>Your requests are not prioritized.</li>
                <li>
                  You can only run {`${requestQuantity} ${requestQuantityText}`}
                  .
                </li>
                <li>
                  Provider responses may be generated based on previous
                  responses.
                </li>
              </ul>
              <Link
                to="/settings/subscription"
                className={classnames(
                  'btn btn-outline-primary',
                  styles.subscribe
                )}
              >
                subscribe
              </Link>
            </div>
          </div>
          <div
            className={classnames(styles.overlayTrigger)}
            onClick={toggleDetail}
          ></div>
        </>
      )}
    </>
  ) : null;
};
